import { t } from '../i18n/lingua'

/**
 * Lo stato di un parametro di Eagle, con colore **e** parola: il colore da solo
 * non basta a chi non lo distingue, e su una stampa in grigio sparisce.
 */

export type StatoEagle = 'ok' | 'warn' | 'crit' | 'down' | 'nodata' | 'pending'

/** Il tono del tema per ogni stato (le classi `badge--*`, `stat--*`, i token). */
export function tonoStato(stato: string | null | undefined): 'ok' | 'warn' | 'error' | 'muted' {
  switch (stato) {
    case 'ok':
      return 'ok'
    case 'warn':
      return 'warn'
    case 'crit':
    case 'down':
      return 'error'
    default:
      return 'muted'
  }
}

export function etichettaStato(stato: string | null | undefined): string {
  switch (stato) {
    case 'ok':
      return t('ok')
    case 'warn':
      return t('attenzione')
    case 'crit':
      return t('critico')
    case 'down':
      return t('non risponde')
    case 'nodata':
      return t('non disponibile')
    case 'pending':
      return t('in attesa')
    default:
      return stato ?? '—'
  }
}

export function StatoBadge({ stato }: { stato: string | null | undefined }) {
  return <span className={`badge badge--${tonoStato(stato)}`}>{etichettaStato(stato)}</span>
}

/** Il pallino di stato accanto a un nome: identità dal colore, parola nel title. */
export function PuntoStato({ stato }: { stato: string | null | undefined }) {
  return <span className={`eagle-punto eagle-punto--${tonoStato(stato)}`} title={etichettaStato(stato)} aria-hidden="true" />
}
